export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapWorkOrders';
export const ENTITY_EDIT_ROUTE = 'assetmanagement/workorders';
